import React, { useState, useEffect } from 'react';
import { NetworkProfile } from './NetworkProfile';
import { NetworkUsers } from './NetworkUsers';
import { NetworkWebContent } from './NetworkWebContent';
import { BusinessListings } from './BusinessListings';

export const NetworkDetailTabs = ({ network }) => {
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem('networkDetailActiveTab') || 'profile';
  });

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    localStorage.setItem('networkDetailActiveTab', tab);
  };

  return (
    <div>
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={'nav-link ' + (activeTab === 'profile' ? 'active' : '')}
            onClick={() => handleTabChange('profile')}
          >
            Network Profile
          </button>
        </li>
        <li className="nav-item">
          <button
            className={'nav-link ' + (activeTab === 'users' ? 'active' : '')}
            onClick={() => handleTabChange('users')}
          >
            Network Users
          </button>
        </li>
        <li className="nav-item">
          <button
            className={'nav-link ' + (activeTab === 'webcontent' ? 'active' : '')}
            onClick={() => handleTabChange('webcontent')}
          >
            Operate Components
          </button>
        </li>
        <li className="nav-item">
          <button
            className={'nav-link ' + (activeTab === 'listings' ? 'active' : '')}
            onClick={() => handleTabChange('listings')}
          >
            Business Listings
          </button>
        </li>
      </ul>

      <div className="tab-content bg-white border border-top-0 rounded-bottom">
        {activeTab === 'profile' && <NetworkProfile network={network} />}
        {activeTab === 'users' && <NetworkUsers network={network} />}
        {activeTab === 'webcontent' && <NetworkWebContent network={network} />}
        {activeTab === 'listings' && <BusinessListings network={network} />}
      </div>
    </div>
  );
};
